import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_INFO_BASE_URL } from '../Constant/constant';

const usePublicInfo = (searchBookName) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null); // ✅ 補上 error 狀態

  useEffect(() => {
    if (!searchBookName) {
      setResults([]);
      setLoading(false);
      setError(null); // ✅ 不要忘了 reset error
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null); // ✅ 每次請求前 reset error

      try {
        const res = await fetch(
          `${PUBLIC_INFO_BASE_URL}/api/nlpi/search?q=${searchBookName}`
        );
        const json = await res.json();

        if (Array.isArray(json?.record)) {
          const parsed = json.record.map((item) => ({
            title: item.t,
            link: `https://ebook.nlpi.edu.tw/bookdetail/${item.sid}`,
            libraries: [],
          }));
          setResults(parsed.slice(0, 10));
        } else {
          setResults([]);
        }
      } catch (err) {
        console.error(err);
        setError(err); // ✅ 錯誤時設 error
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [location.search, searchBookName]);

  return { results, loading, error }; // ✅ 加上 error
};

export default usePublicInfo;
